<script setup lang="ts">
import RelationView from '@desktop/views/Relation/components/RelationView/RelationView.vue'
import { initSportConfiguration } from '@desktop/views/Relation/Sports/provide-inject'

import VolleyballRelation from './components/RelationView/VolleyballRelation.vue'
import VolleyballStatistics from './components/RelationView/VolleyballStatistics.vue'
import {
  addIncidentConfig,
  assignPlayerOnPitchConfig,
  customIncidentNames,
  eventInfoControls,
  eventRelatedStatusConfig,
  eventStatuses,
  eventStatusIncidentsOnFieldConfig,
  historyFiltersConfig,
  historyIncidentsConfig,
  incidentsQueuePayloadConfig,
  incidentsResultConfig,
  lineupConfig,
  manualAddIncidentConfig,
  pitchBlockedEventStatus,
  pitchIncidentsConfig,
  pitchOverlaySupportedStatuses,
  playersConfig,
  pocketIncidentsConfig,
  resultWithSliderConfig,
} from './configuration'

initSportConfiguration({
  addIncidentConfig,
  hasChangeSides: true,
  customIncidentNames,
  defaultSkinPatternId: 12,
  eventInfoControls,
  eventRelatedStatusConfig,
  eventStatuses,
  historyFiltersConfig,
  historyIncidentsConfig,
  incidentsQueuePayloadConfig,
  incidentsResultConfig,
  lineupConfig,
  manualAddIncidentConfig,
  playersConfig,
  pitch: {
    assignPlayerOnPitchConfig,
    eventStatusIncidentsOnFieldConfig,
    pitchBlockedEventStatus,
    pitchIncidentsConfig,
    pitchOverlaySupportedStatuses,
  },
  pocketIncidentsConfig,
  resultWithSliderConfig,
})
</script>

<template>
  <RelationView
    :relation="VolleyballRelation"
    :statistics="VolleyballStatistics"
  />
</template>
